<script setup>
import { computed, ref } from 'vue';
import AppMenuItem from './AppMenuItem.vue';
import config from '@/config';
import { useUserSession } from '@/stores/userSession';
import { filterMenuItems } from '@/utils/menuVisibility';

const userSession = useUserSession();

const model = ref([
    {
        label: 'Integration Lab',
        icon: 'integration-lab-image-sidemenu',
        to: '/integration-lab/list',
        name: 'integration-lab',
        requiresAuth: true,
        allowedUsers: [config.userType.admin, config.userType.user]
    },
    {
        label: 'PS Customer Server',
        icon: 'ps-customer-image-sidemenu',
        to: '/ps-customer-server/list',
        name: 'ps-customer-server',
        requiresAuth: true,
        allowedUsers: [config.userType.admin, config.userType.user]
    },
    {
        label: 'PS Estimate',
        icon: 'ps-customer-image-sidemenu',
        to: '/ps-estimate/list',
        name: 'ps-estimate',
        requiresAuth: true,
        allowedUsers: [config.userType.admin, config.userType.user]
    },
    {
        label: 'License Tracker',
        icon: 'ps-customer-image-sidemenu',
        to: '/license-tracker/list',
        name: 'license-tracker',
        requiresAuth: true,
        allowedUsers: [config.userType.admin, config.userType.user]
    },
    {
        label: 'Site Assessment',
        icon: 'site-assessment-image-sidemenu',
        to: '/site-assessment/list',
        name: 'site-assessment',
        requiresAuth: true,
        allowedUsers: [config.userType.admin, config.userType.user]
    },
    {
        label: 'Surveillance <br> Tools',
        icon: 'noun-heartbeat',
        items: [
            {
                label: 'Patient Tile Designer',
                to: '/patient-tile-composer/list',
                name: 'patient-tile-composer',
                requiresAuth: true,
                allowedUsers: [config.userType.admin, config.userType.user]
            },
        ],
        requiresAuth: true,
        allowedUsers: [config.userType.admin, config.userType.user]
    },
    {
        label: 'MP1 Data Analyzer',
        icon: 'pi pi-chart-line',
        to: '/mp1-data-analyzer/analyzer',
        name: 'mp1-data-analyzer',
        requiresAuth: true,
        allowedUsers: [config.userType.admin]
    },
    {
        label: 'Go-Live',
        icon: 'pi pi-envelope',
        to: '/go-live-generator',
        name: 'go-live-generator',
        requiresAuth: true,
        allowedUsers: [config.userType.admin, config.userType.user]
    },
    {
        label: 'Cables Lookup',
        icon: 'cables-lookup-image',
        to: '/cables-lookup',
        name: 'cables-lookup',
        requiresAuth: true,
        allowedUsers: [config.userType.admin, config.userType.user]
    },
    {
        label: 'Admin Tools',
        icon: 'pi pi-cog',
        items: [
            {
                label: 'Deployment Settings',
                icon: 'pi pi-cog',
                to: '/admin/deployment-settings',
                name: 'deployment-settings',
                requiresAuth: true,
                allowedUsers: [config.userType.admin]
            },
            {
                label: 'Login History',
                icon: 'pi pi-history',
                to: '/admin/login-history',
                name: 'login-history',
                requiresAuth: true,
                allowedUsers: [config.userType.admin]
            },
            {
                label: 'DDI Library',
                icon: 'ddi-library-image',
                to: '/ddi-library/list',
                name: 'ddi-library',
                requiresAuth: true,
                allowedUsers: [config.userType.admin]
            },
            {
                label: 'Master Variable',
                icon: 'master-variable-image',
                to: '/master-variable/list',
                name: 'master-variable',
                requiresAuth: true,
                allowedUsers: [config.userType.admin]
            },
            {
                label: 'Data Sync',
                icon: 'data-sync-image',
                to: '/data-sync/list',
                name: 'data-sync',
                requiresAuth: true,
                allowedUsers: [config.userType.admin]
            },
            {
                label: 'Gateway Management',
                icon: 'gateway-management-image',
                to: '/gateway-management/index',
                name: 'gateway-management',
                requiresAuth: true,
                allowedUsers: [config.userType.admin]
            },
            {
                label: 'Unit',
                icon: 'unit-image',
                to: '/unit/list',
                name: 'unit',
                requiresAuth: true,
                allowedUsers: [config.userType.admin]
            },
        ],
        requiresAuth: true,
        allowedUsers: [config.userType.admin]
    },
]);

const filteredModel = computed(() =>
    filterMenuItems(
        model.value,
        Number(userSession.user.userType),
        userSession.user.email
    )
);
</script>

<template>
    <ul class="layout-menu !mt-[30px]">
        <template v-for="(item, i) in filteredModel" :key="item.label + i">
            <AppMenuItem :item="item" root :index="i" />

            <li class="menu-separator"></li>
        </template>
    </ul>
</template>

<style lang="scss" scoped></style>
